import * as actions from "../action.constants";

const initialState = {
  eventRulesListData: {},
  contentTypesListData: {},
  eventFieldTypesListData: {},
  eventWebhooksListData: {},
};

const saveEventRules = (state, action) => ({
  ...state,
  eventRulesListData: action.payload || {},
});

const saveContentTypes = (state, action) => ({
  ...state,
  contentTypesListData: action.payload || {},
});

const saveEventFieldTypes = (state, action) => ({
  ...state,
  eventFieldTypesListData: action.payload || {},
});
const saveEventWebhooks = (state, action) => ({
  ...state,
  eventWebhooksListData: action.payload ?? [],
});

const handlers = {
  [actions.SAVE_EVENT_RULES]: saveEventRules,
  [actions.SAVE_CONTENT_TYPES]: saveContentTypes,
  [actions.SAVE_EVENT_FIELD_TYPES]: saveEventFieldTypes,
  [actions.SAVE_EVENT_WEBHOOKS]: saveEventWebhooks,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
